export enum UserTypes {
  PARENT = 'parent',
  STUDENT = 'student',
  EMPLOYEE = 'employee',
  INDIVIDUAL = 'individual',
}
